module.exports = __webpack_public_path__ + "static/media/takahiro-sakamoto.64153c99.jpg";